<template>
  <v-app class="cor">
    <MenuMb class="d-lg-none" v-if="user" />
    <Menu class="d-none d-lg-flex" v-if="user" /> 
    
    <Header v-if="user" :title="$store.state.title" :hideToggle="!user" :hideUserDropdown="!user" />
    
      <Content />
    
    <Footer class="d-none d-lg-flex" v-if="user"/>
  </v-app>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import Header from './components/template/Header'
import Content from './components/template/Content'
import { baseApiUrl, userKey } from "@/config/global"
import Menu from './components/template/Menu'
import MenuMb from './components/template/MenuMb'
import Footer from './components/template/Footer'

export default {
  name: 'app',
  components: { 
    Header, 
    Menu,
    MenuMb,
    Footer,
    Content
  },
  computed: mapState(['isMenuVisible', 'user', 'buscandoDados']),
  data(){
    return{
      validatingToken: true,
    }
  },

  methods:{
    async validateToken(){
      this.validationToken = true

      const json = sessionStorage.getItem(userKey)
      const userData = JSON.parse(json)
      this.$store.commit('setUser', null)

      if(!userData){
        this.validatingToken = false
        this.$router.push({ name: 'auth'})
        return
      }

      const res = await axios.post(`${baseApiUrl}/utils/validateToken.php`, userData)
            
      if(res.data.codigo == '01'){
        
        this.$store.commit('setUser', userData)

        if(this.$mq === 'xs' || this.$mq === 'sm'){
          this.$store.commit('toggleMenu', false)
        }
        
      }else{
        sessionStorage.removeItem(userKey)
        this.$router.push({ name: 'auth' })
      }

      this.validatingToken = false
    }
  },

  mounted(){
    
      let url = window.location.href.split('/')
      if(url[2].substring(0,3) == "www"){
        window.location.replace("https://membros.ofedl.com/auth")
      }
      let tk = ""
      let confirmar = 0
      let novaSenha = url.some(v=>{
                        return v == 'novaSenha'
                      })
      let confirmarAtendimento = url.some(v=>{
        return v == 'confirmarAtendimento'
      })
      
      let auth = url.some(v=>{
        return v == 'auth'
      })

        if(novaSenha){
          tk = url[4]
          this.$store.commit('setUser', null)
          this.$router.push({name: 'NovaSenha', params: {token: tk}})

        }else if(confirmarAtendimento){
          confirmar = url[4]
          tk = url[5]
          this.$store.commit('setUser', null)
          this.$router.push({name: 'ConfirmacaoAtendimento', params: {token: tk, confirmado: confirmar}})

        }else if(auth){
          this.validateToken()

        }else{
          const json = sessionStorage.getItem(userKey)
          if(json == null){
            this.$router.push({name: 'auth'})
            return
          }else{
            if(this.user == null){
              this.$store.commit('setUser', JSON.parse(json))
            }
          }

        }
  }
}

</script>

<style scoped>

</style>

